import { isNil, omitBy, map, filter, indexOf } from "lodash";

const response = (data: any) => {
    //this is to get rid of the object names and combining the arrays together
    let normalizedArray: any = [];
    data.map((a: any) => {
        console.log("a", a);
        a.newOrderObject.map((b: any) => {
            normalizedArray.push(b);
        });
        a.newBoxObject.map((c: any) => {
            normalizedArray.push(c);
        });
    });

    return normalizedArray;
};

export default response;
